<div class="main">
    <ul class="cards">
        <li class="cards_item">
            <a routerLink="/protecting-sensitive-mobile-apps-on-rooted-device">
                <div class="card">
                    <div class="card_image"><img src="assets/images/blog/rooted_devices_1.webp" alt="rooted devices 1"></div>
                    <div class="card_content">
                        <!-- <h5 class="card_title">Protecting Sensitive Mobile Apps on
                            Rooted
                            Devices</h5> -->
                        <p class="card_text">Rooting is the act of obtaining root or administrative access to the
                            Android operating system, which is typically restricted for security reasons.When a device
                            is rooted, the user gain...
                        </p>
                        <!-- <button class="btn text-center">Read More</button> -->
                        <a routerLink="/protecting-sensitive-mobile-apps-on-rooted-device" class="btn btn-primary">Read
                            More</a>
                    </div>
                </div>
            </a>
        </li>
        <li class="cards_item">
            <a routerLink="/rasp-in-era-of-devsecops">
                <div class="card">
                    <div class="card_image"><img src="assets/images/blog/devsecops_1.webp" alt="devsecops 1"></div>
                    <div class="card_content">
                        <!-- <h5 class="card_title">Runtime Application Self-Protection (RASP) for Mobile App Security in the
                            Era of DevSecOps</h5> -->
                        <p class="card_text">In today's fast-paced and ever-evolving digital threat landscape, mobile
                            app security has become a top priority for corporates. In 2022, 28 Bn Mobile apps have been
                            downloaded...
                        </p>
                        <!-- <button class="btn text-center">Read More</button> -->
                        <a routerLink="/rasp-in-era-of-devsecops" class="btn btn-primary">Read
                            More</a>
                    </div>
                </div>
            </a>
        </li>
        <li class="cards_item">
            <a routerLink="/risk_and_impacts_of_accessibility_permission">
                <div class="card">
                    <div class="card_image"><img src="assets/images/blog/accessibility_permission_1.webp" alt="accessibility permission 1"></div>
                    <div class="card_content">
                        <!-- <h5 class="card_title">The Risk and Impact of Accessibility
                            Permission
                            on Mobile Apps</h5> -->
                        <p class="card_text">The accessibility permission is a feature in mobile operating systems that
                            allow applications to access user interactions with the device's interface enabling
                            assistive technologies for...
                        </p>
                        <!-- <button class="btn text-center">Read More</button> -->
                        <a routerLink="/risk_and_impacts_of_accessibility_permission" class="btn btn-primary">Read
                            More</a>
                    </div>
                </div>
            </a>
        </li>
    </ul>
    <div class="row justify-content-center pt-1 pb-3">
        <a routerLink="/blogs" class="btn btn-primary">See More Blogs</a>
    </div>
    
</div>